import type { ComponentProps } from "react";

import { cn } from "@/utils/cn";

interface ImageProps extends Omit<ComponentProps<"img">, "loading"> {
  priority?: boolean;
  quality?: number;
  fill?: boolean;
}

export const Image = ({
  priority = false,
  quality: _quality,
  fill,
  sizes,
  alt = "",
  className,
  ...props
}: ImageProps) => (
  <img
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    sizes={sizes}
    alt={alt}
    className={cn(
      {
        "absolute inset-0 h-full w-full": fill,
      },
      className,
    )}
    {...props}
  />
);
